import { useState } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import FeaturesSection from "./components/FeaturesSection";
import HowItWorks from "./components/HowItWorks";
import ComprobantesTable from "./components/ComprobantesTable";
import IntegrationTabs from "./components/IntegrationTabs";
import MetricsSection from "./components/MetricsSection";
import PricingSection from "./components/PricingSection";
import FAQSection from "./components/FAQSection";
import SupportButton from "@/components/base/SupportButton";

export default function HomePage() {
  const [darkMode, setDarkMode] = useState(false);

  return (
    <div className={darkMode ? "dark" : ""}>
      <div className={darkMode ? "bg-slate-950 text-white" : "bg-white text-slate-900"}>
        <Navbar darkMode={darkMode} onToggleDark={() => setDarkMode(!darkMode)} />
        <main>
          <HeroSection />
          <MetricsSection />
          <FeaturesSection />
          <HowItWorks />
          <ComprobantesTable />
          <IntegrationTabs />
          <PricingSection />
          <FAQSection />
        </main>
        <Footer darkMode={darkMode} />
        <SupportButton />
      </div>
    </div>
  );
}